import React from "react";
import { CheckCircle, Cancel } from "@mui/icons-material";
import { alpha, Box, Paper, Stack, Typography } from "@mui/material";
import { ChecklistItem } from "../../hooks/useSEOAnalysis";

interface SEOChecklistCardProps {
  checklist: ChecklistItem[];
}

const SEOChecklistCard: React.FC<SEOChecklistCardProps> = ({ checklist }) => (
  <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3 }}>
    <Typography fontWeight={800} mb={2}>
      SEO Checklist
    </Typography>
    <Stack spacing={0.5}>
      {checklist.map((item) => (
        <Box
          key={item.key}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.5,
            p: 1.25,
            borderRadius: 2,
            bgcolor: (theme) =>
              alpha(
                theme.palette[item.passed ? "success" : "error"].main,
                0.08,
              ),
          }}
        >
          {item.passed ? (
            <CheckCircle color="success" fontSize="small" sx={{ mt: 0.25 }} />
          ) : (
            <Cancel color="error" fontSize="small" sx={{ mt: 0.25 }} />
          )}
          <Box>
            <Typography variant="body2" fontWeight={700}>
              {item.label}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {item.passed ? item.passedText : item.failedText}
            </Typography>
          </Box>
        </Box>
      ))}
    </Stack>
  </Paper>
);

export default SEOChecklistCard;
